var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{style:('width:'+_vm.width+';')},_vm._l((_vm.options),function(option,i){return _c('li',{key:'option-'+i.toString()},[_vm._t('option-'+i.toString(),[_vm._v(" "+_vm._s(option)+" ")])],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }